/**
 * The release this build is, read from `index.html` rather than compiled in. Compiled in, it
 * changed the chunk that every screen imports, so every release renamed every chunk.
 */
export const releaseVersion = document.querySelector<HTMLMetaElement>('meta[name="release-version"]')?.content || "dev";
